export const RESET_CLIENT_SYSTEM_VALUES = "RESET_CLIENT_SYSTEM_VALUES";
export const RESET_CLIENT_SYSTEM_VALUE = "RESET_CLIENT_SYSTEM_VALUE";
export const RESET_ERROR = "RESET_ERROR";

export const GET_CLIENT_SYSTEM_VALUES = "GET_CLIENT_SYSTEM_VALUES";
export const SET_CLIENT_SYSTEM_VALUES = "SET_CLIENT_SYSTEM_VALUES";

export const API_ERROR = "CLIENT_SYSTEM_VALUES_API_ERROR";

export const GET_CLIENT_SYSTEM_VALUE = "GET_CLIENT_SYSTEM_VALUE";
export const SET_CLIENT_SYSTEM_VALUE = "SET_CLIENT_SYSTEM_VALUE";

export const EDIT_CLIENT_SYSTEM_VALUE = "EDIT_CLIENT_SYSTEM_VALUE";
export const EDIT_CLIENT_SYSTEM_VALUE_SUCCESS = "EDIT_CLIENT_SYSTEM_VALUE_SUCCESS";

export const CREATE_CLIENT_SYSTEM_VALUE = "CREATE_CLIENT_SYSTEM_VALUE";
export const CREATE_CLIENT_SYSTEM_VALUE_SUCCESS = "CREATE_CLIENT_SYSTEM_VALUE_SUCCESS";

export const DELETE_CLIENT_SYSTEM_VALUE = "DELETE_CLIENT_SYSTEM_VALUE";
export const DELETE_CLIENT_SYSTEM_VALUE_SUCCESS = "DELETE_CLIENT_SYSTEM_VALUE_SUCCESS";
